import { sk } from "date-fns/locale";
import React from "react";
import { Link } from "react-router-dom";

export default function MySkills(){
    const skills = [
      {
        id: 1,
        name: "javascript",
        src: "https://img.icons8.com/?size=100&id=39854&format=png&color=000000",
        description: "I use JavaScript to build dynamic, interactive web applications, ensuring a seamless and engaging user experience while maintaining performance and quality.",
        title: "JavaScript Developer"
      },
      {
        id: 2,
        name: "python",
        src: "https://img.icons8.com/?size=100&id=Rc0Xn5AtE8kX&format=png&color=000000",
        description: "I leverage Python to develop robust and secure databases, both relational and non-relational, while optimizing for speed and scalability in handling requests.",
        title: "Python Developer"
      },
      {
        id: 3,
        name: "react",
        src: "https://img.icons8.com/?size=100&id=t4YbEbA834uH&format=png&color=000000",
        description: "I utilize React, a JavaScript library, to create modern, responsive web applications that are easy to deploy and provide an intuitive user interface.",
        title: "React Developer"
      },
      {
        id: 4,
        name: "flask",
        src: "https://img.icons8.com/?size=100&id=ewGOClUtmFX4&format=png&color=000000",
        description: "I use Flask, a Python framework, to build efficient and secure backends with accessible routes, ensuring fast and reliable data handling.",
        title: "Flask Developer"
      },
      {
        id: 5,
        name: "html5",
        src: "https://img.icons8.com/?size=100&id=20909&format=png&color=000000",
        description: "I use HTML5 to design the structure of web pages, creating clean, accessible, and visually appealing content for users.",
        title: "HTML Developer"
      },
      {
        id: 6,
        name: "css3",
        src: "https://img.icons8.com/?size=100&id=7gdY5qNXaKC0&format=png&color=000000",
        description: "I integrate CSS3 to style and enhance HTML structures, delivering visually appealing and user-friendly web pages that meet modern standards.",
        title: "CSS Developer"
      },
      {
        id: 7,
        name: "tailwind-css",
        src: "https://img.icons8.com/?size=100&id=FnnFuAIw4e8j&format=png&color=000000",
        description: "I use Tailwind CSS to style web pages efficiently, employing its modern utility-first approach to create responsive and user-friendly designs.",
        title: "Tailwind CSS Developer"
      },
      {
        id: 8,
        name: "Typescript",
        src: "https://img.icons8.com/?size=100&id=HcQEdKCkXUs3&format=png&color=000000",
        description: "I use Typescript  to be able to create functionalities of applications to make users easily interact with applications",
        title: "Typescript developer"
      },
      {
        id: 9,
        name: "Vite js",
        src: "https://img.icons8.com/?size=100&id=dJjTWMogzFzg&format=png&color=000000",
        description: "I use Vite js in combination with typescript to create full stack applications that users can use and be able to interact with the application",
        title: "Vite js developer"
      },
      // {
      //   id: 9,
      //   name: "Next js",
      //   src: "https://img.icons8.com/?size=100&id=dJjTWMogzFzg&format=png&color=000000",
      //   description: "I use Next js in combination with typescript to create full stack applications that users can use and be able to interact with the application and experience an interactive application",
      //   title: "Next js Developer"
      // },
      {
        id: 10,
        name: "Sqlite",
        src: "https://img.icons8.com/?size=100&id=yjSayFwWHyCo&format=png&color=000000",
        description: "I use sqlite to to create backend databases which users can easily interact with through request from fontend appications for easy and secure access,retreival,storage and interaction",
        title: "sqlite Developer"
      },
       {
        id: 11,
        name: "Postgresql",
        src: "https://img.icons8.com/?size=100&id=JRnxU7ZWP4mi&format=png&color=000000",
        description: "I use postgresql  to to create backend databases which users can easily interact with through request from fontend appications for easy and secure access,retreival,storage and interaction",
        title: "Postgresql Developer"
      },
       {
        id: 12,
        name: "MongoDb,Node js",
        src: "https://img.icons8.com/?size=100&id=8rKdRqZFLurS&format=png&color=000000",
        description: "I use Mongo db in combination with node js to create backend databases which users can easily interact with through request from fontend appications for easy and secure access,retreival,storage and interaction",
        title: "Mongo Db,Nodejs Developer"
      }
    ];
    

   
    return (
        <section className="skills--section bg-gray-50" id="MySkills">
          <div className="portfolio--container flex items-center justify-center">
            <h2 className="skills--section--heading ">My Skills</h2>
          </div>
          <div className="skills--section--container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {skills.map((item, index) => (
              <div key={index} className="skills--section--card h-[450px] shadow-md hover:shadow-lg duration-300 rounded-2xl">
                <div className="skills--section--img w-full h-52 rounded-lg h-32 bg-white flex items-center justify-center">
                  <img src={`${item.src}`} alt={`Image${item.id}`}  className="h-20 w-20 rounded-full"/>
                  {/* <i className={`bx bxl-${item.name} w-full h-[40px] rounded-full` } alt="Product Chain" ></i> */}
                </div>
                <div className="skills--section--card--content">
                  <h3 className="skills--section--title text-gray-700 mb-2 font-semibold ">{item.title}</h3>
                  <p className="skills--section--description">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>
      );
}

{/* <div className="skills-slider">
                {/* Top row */}
            //     <div className="skills-row row1">
            //         {skills.map(skill => (
            //             <div key={skill.id} className="skills--card">
            //                 <i className={`bx bxl-${skill.name}`}></i>
            //                 <p className="skills--title">{skill.title}</p>
            //             </div>
            //         ))}
            //     </div>
            //     {/* Bottom row */}
            //     <div className="skills-row row2">
            //         {skills.map(skill => (
            //             <div key={skill.id} className="skills--card">
            //                 <i className={`bx bxl-${skill.name}`}></i>
            //                 <p className="skills--title">{skill.title}</p>
            //             </div>
            //         ))}
            //     </div>
            // </div> */}